module.exports = __webpack_public_path__ + "img/arrow_up_square.46b70ed9.svg";